<script>
import { defineComponent } from 'vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import TwGridDual from '@/components/generic/tw-grid-dual.vue'
import modalCascadeMixin from '@/mixins/modalCascadeMixin.js'

export default defineComponent({
  name: 'RedpodiumApiTokensModal',
  components: { TwGridDual, TwModal },
  mixins: [modalCascadeMixin],
  props: {
    apiToken: {
      type: Object,
      required: true
    }
  }
})
</script>

<template>
  <tw-modal ref="modal" title="Example for RedPodium Integration" ok-only @ok="close()">
    <div class="mb-10">
      In your RedPodium Account, go to the <strong>Extras</strong> section and select <strong>Integrations</strong>. Here click the <strong>Add Integration</strong> button and select <strong>Webhook</strong> from the available options.
    </div>

    <div>
      <h4> Fill the following fields with the data: </h4>
      <div> <strong class="text-blue-500">Name:</strong> GroupRev </div>
      <div> <strong class="text-blue-500">App Key:</strong> RedPodium </div>
      <div> <strong class="text-blue-500">App/API Token:</strong> {{ apiToken.raw_token }} </div>
      <div> <strong class="text-blue-500">URL:</strong> {{ apiToken.api_end_point_url }} </div>
    </div>
    <div class="mt-6">
      On the right side, select the <strong>New Registrations</strong> event, and turn it On with the toggle switch.
    </div>

    <div>
      Then on the bottom select for which event you want to create fundraisers in this campaign.
    </div>
  </tw-modal>
</template>

<style scoped>

</style>
